import { render, staticRenderFns } from "./PortofolioSteps.vue?vue&type=template&id=4949ca46&scoped=true"
import script from "./PortofolioSteps.vue?vue&type=script&lang=js"
export * from "./PortofolioSteps.vue?vue&type=script&lang=js"
import style0 from "./PortofolioSteps.vue?vue&type=style&index=0&id=4949ca46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4949ca46",
  null
  
)

export default component.exports